import api from '../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormChecklistGroup from './Form/FormChecklistGroup'

function NewChecklistGroup({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerChecklistGroup(checklistGroup) {
        let msgType = 'success'

        const data = await api.post('/checklistGroup/new', checklistGroup, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess(data.newChecklistGroup)
        }
    }

    return (
        <section>
            <FormChecklistGroup
                title="Novo Grupo de Checklist"
                handleSubmit={registerChecklistGroup}
                btCancelAction={btCancelAction}
            />
        </section>
    )
}

export default NewChecklistGroup
